import { Grid } from '@mui/material';
import ProductionCardLoader from '../../Dashboard/components/SkeletonLoader/ProductionCardLoader';

const RiskCardLoader = ({ className }: any) => {
  return (
    <>
      <div className={className ? className : `card-loader-sction`}>
        <Grid container rowGap={1} columnSpacing={2}>
          <Grid item md={3} sm={4} xs={12}>
            <ProductionCardLoader />
          </Grid>
          <Grid item md={3} sm={4} xs={12}>
            <ProductionCardLoader />
          </Grid>
          <Grid item md={3} sm={4} xs={12}>
            <ProductionCardLoader />
          </Grid>
          <Grid item md={3} sm={4} xs={12}>
            <ProductionCardLoader />
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default RiskCardLoader;
